import React, { FC } from 'react';

import moment from 'moment';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box, Drawer, Grid, IconButton, Typography } from '@mui/material';

interface OOMailDetailsProps {
  detailControls: any;
}

const MailDetails: FC<OOMailDetailsProps> = ({ detailControls }) => {
  const { isActive, onClose, selectedBulkMail } = detailControls;

  return (
    <Drawer open={isActive} anchor="right" onClose={onClose}>
      <div className="admin" style={{ height: '100%', padding: '10px', maxWidth: 500 }}>
        <div className="oo-mail-overview-container">
          <Box display="flex" mb={2} justifyContent="space-between">
            <div>
              <h3>Details</h3>
            </div>
            <IconButton onClick={onClose}>
              <CloseRoundedIcon color="primary" />
            </IconButton>
          </Box>
        </div>
        <Box>
          <Grid container spacing={2}>
            {/* Row 1 */}
            <Grid item xs={4}>
              <Typography variant="subtitle1">Template type</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">{selectedBulkMail?.details?.templateType}</Typography>
            </Grid>

            {/* Row 2 */}
            <Grid item xs={4}>
              <Typography variant="subtitle1">Date</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">{moment(selectedBulkMail?.createdAt)?.format('DD/MM/YYYY') ?? ''}</Typography>
            </Grid>

            {/* Row 3 */}
            <Grid item xs={4}>
              <Typography variant="subtitle1">Time</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">{moment(selectedBulkMail?.createdAt)?.format('HH:mm:ss') ?? ''}</Typography>
            </Grid>

            {/* Row 4 */}
            <Grid item xs={4}>
              <Typography variant="subtitle1">Sent by</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">{selectedBulkMail?.details?.sentBy}</Typography>
            </Grid>
          </Grid>
        </Box>
      </div>
    </Drawer>
  );
};

export default MailDetails;
